<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";

export default {
  components: { validationMessages },

  data() {
    return {
      brand_name: "",
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      attrName:'',
      attrDescription:'',
      attrVisibility:1,
      attrType:'',
      attrOrder:'',

    };
  },

  validations: {
    attrName: { required },
    attrVisibility: { required, numeric },
    attrOrder: { required, numeric },
  },

  methods: {


    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      this.showLoader = true;
      let formData = new FormData();
      formData.append("name", this.attrName);
      formData.append("description", this.attrDescription);
      formData.append("visibility", this.attrVisibility);
      formData.append("type", this.attrType);
      formData.append("order", this.attrOrder);

      try {
        const response = await Merchandising.addAttribute(formData);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to create attribute. Please try again.", "error");
        } else {
          Swal.fire("Success", "Attribute successfully added!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create attribute:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to create attribute. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },


    resetForm() {
      this.$v.$reset();
      this.attrName = '';
      this.attrDescription = '';
      this.attrVisibility = 1;
      this.attrType = '';
      this.attrOrder = '';


    },

    closeModal() {
      this.resetForm();
      this.showModal = false;
    },



    refreshData() {
      this.$emit("onRefresh");
    },
  },
};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      id="add_attribute"
      size="l"
      v-model="showModal"
      title="Add Attribute"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="$v.$error" class="text-danger">Complete all fields</div>
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <b-form-group label="Attribute Name" class="mb-3">
              <b-form-input
                  v-model.trim="attrName"
                  :class="{ 'is-invalid': submitted && $v.attrName.$error }"
              ></b-form-input>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Attribute Name'"
                  :validationName="$v.attrName"
              ></validationMessages>
            </b-form-group>

            <b-form-group label="Attribute Description" class="mb-3">
              <b-form-input
                  v-model.trim="attrDescription"
              ></b-form-input>
            </b-form-group>


            <b-form-group label="Attribute Visibility" class="mb-3">
              <div class=" form-check form-switch form-switch-lg">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="switch1"
                    :true-value="1"
                    :false-value="0"
                    v-model.trim="attrVisibility"
                    :class="{ 'is-invalid': submitted && $v.attrVisibility.$error }"
                />

              </div>

              <validationMessages
                  v-if="submitted"
                  :fieldName="'Attribute Visibility'"
                  :validationName="$v.attrVisibility"
              ></validationMessages>
            </b-form-group>

            <b-form-group label="Attribute Type" class="mb-3">
              <b-form-input
                  v-model.trim="attrType"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Attribute Order" class="mb-3">
              <b-form-input
                  v-model.trim="attrOrder"
                  :class="{ 'is-invalid': submitted && $v.attrOrder.$error }"
              ></b-form-input>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Attribute Order'"
                  :validationName="$v.attrOrder"
              ></validationMessages>
            </b-form-group>
          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
